module.exports = __webpack_public_path__ + "img/2.e1ce890b.png";